module.exports = __webpack_public_path__ + "static/media/25ton-variant-6.f6048b9d.jpg";